import React from "react";
import { Modal } from "react-bootstrap";
import styles from "../../_css/DeleteUserModal.module.css";
import {
  CustomButton,
  CustomButtonDanger,
  CustomButtonOutlineLight,
} from "../UI/CustomButtons";
import { DOWNLOAD_SUMMARY_MODAL } from "../../data/modelsData";
import { useSelector } from "react-redux";

const DownloadSummary = ({ show, onHide, onDownload, pdfStatus }) => {
  const lang = useSelector((state) => state.language.lang);
  const { title, description, btnText } = DOWNLOAD_SUMMARY_MODAL[lang];
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className={styles.endSessionModal}
    >
      <Modal.Header className={" p-3 py-2"} closeButton>
        <Modal.Title
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: "var(--color-1)",
          }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className={styles.iconSection}>
          <div className={styles.iconCircle}>
            <i>
              <img
                width={60}
                src={`${process.env.REACT_APP_PROJECT_URL}/img/download.png`}
                alt="download"
              />
            </i>
          </div>
          <div className={styles.title}>{description}</div>
        </div>
        <div
          className={
            styles.buttonRow + " d-flex justify-content-center gap-3 mt-4"
          }
        >
          <CustomButtonOutlineLight
            text={btnText[0]}
            onClick={onHide}
            width="100%"
          />
          <CustomButton
            icon="download"
            gap="8px"
            text={pdfStatus || btnText[1]}
            onClick={onDownload}
            width="100%"
            disabled={pdfStatus}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DownloadSummary;
